import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export const useGetByRequestId = (requestId?: string) => {
  return useQuery({
    queryKey: ['engagement', 'request-id', requestId],
    queryFn: async () => {
      const { data } = await apiClient.get<string>(`/int/v3/engagements/request/${requestId}`)
      return data
    },
    enabled: Boolean(requestId),
  })
}
